import { RouterView } from "vue-router";

export const teachersRoute = {
  path: ":menu/teachers",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/teachers/list/index.vue"),
    },
  ],
};
